import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFeatures } from '../contexts/FeaturesContext';
import { useAuth } from '../contexts/AuthContext';
import Logo from './Logo';

export default function Footer() {
  const { t } = useTranslation();
  const { features } = useFeatures();
  const { user } = useAuth();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#0c1c36] mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col sm:flex-row justify-between gap-10">
          <div>
            <div className="flex items-center gap-2">
              <Logo size={28} className="brightness-0 invert" />
              <span className="font-heading font-extrabold text-sm tracking-wide text-white">
                GRENZLAND PADEL LIGA
              </span>
            </div>
            <p className="text-sm text-[#7c8aa3] mt-3 max-w-xs leading-relaxed">
              Padel-Liga für Flensburg und die Grenzregion Deutschland/Dänemark.
            </p>
          </div>

          <div className="flex gap-14 flex-wrap">
            {(features.liga || features.saison) && (
              <div>
                <div className="text-white font-semibold text-sm mb-3">Liga</div>
                <div className="flex flex-col gap-2 text-sm text-[#8592a8]">
                  {features.liga && (
                    <Link to="/leagues" className="hover:text-accent-400 transition-colors">{t('nav.leagues')}</Link>
                  )}
                  {features.saison && (
                    <>
                      <Link to="/seasons" className="hover:text-accent-400 transition-colors">{t('nav.seasons')}</Link>
                      <Link to="/ranking" className="hover:text-accent-400 transition-colors">{t('nav.ranking')}</Link>
                    </>
                  )}
                  <Link to="/courts" className="hover:text-accent-400 transition-colors">{t('nav.courts')}</Link>
                </div>
              </div>
            )}

            <div>
              <div className="text-white font-semibold text-sm mb-3">Konto</div>
              <div className="flex flex-col gap-2 text-sm text-[#8592a8]">
                {user ? (
                  <>
                    {(features.liga || features.saison) && (
                      <Link to="/pairs" className="hover:text-accent-400 transition-colors">{t('nav.myPair')}</Link>
                    )}
                    {(features.mannschaft || features.saison) && (
                      <Link to="/teams" className="hover:text-accent-400 transition-colors">{t('nav.myTeam')}</Link>
                    )}
                    <Link to="/dashboard" className="hover:text-accent-400 transition-colors">{t('nav.dashboard')}</Link>
                  </>
                ) : (
                  <>
                    <Link to="/login" className="hover:text-accent-400 transition-colors">{t('nav.login')}</Link>
                    <Link to="/register" className="hover:text-accent-400 transition-colors">{t('nav.register')}</Link>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#657191]">
          <span>© {year} Grenzland Padel Liga</span>
          <nav className="flex items-center gap-5">
            <Link to="/datenschutz" className="hover:text-accent-400 transition-colors">{t('footer.datenschutz')}</Link>
            <Link to="/impressum" className="hover:text-accent-400 transition-colors">{t('footer.impressum')}</Link>
            <Link to="/agb" className="hover:text-accent-400 transition-colors">{t('footer.agb')}</Link>
            <a href="mailto:grenzland-liga@padelmap.app" className="hover:text-accent-400 transition-colors">
              {t('footer.contact')}
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
